/* dc-catalog.js — filtros de categoría + producto estrella (vanilla, defer) */
(() => {
  'use strict';

  // Filtros: <dc-filters> con [data-filter], filtra [data-cat] en el grid destino (data-target)
  class DCFilters extends HTMLElement {
    connectedCallback() {
      const targetSel = this.dataset.target || '[data-dc-grid]';
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-filter]');
        if (!btn) return;
        const cat = btn.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach((b) => b.classList.toggle('is-active', b === btn));
        document.querySelectorAll(targetSel + ' [data-cat]').forEach((card) => {
          const show = cat === 'todos' || card.dataset.cat === cat;
          card.style.display = show ? '' : 'none';
        });
      });
    }
  }

  // <dc-star>: auto-cicla la imagen; los swatches [data-star-index] la cambian.
  // Fuente de datos, en orden: data-images (lista simple) o un
  // <script type="application/json" data-dc-colors> del snippet dc-variant-colors,
  // que además trae nombre, precio e id de variante por color.
  class DCStar extends HTMLElement {
    connectedCallback() {
      this.imgs = [];
      this.colors = [];
      try { this.imgs = JSON.parse(this.dataset.images || '[]'); } catch (e) {}
      const src = this.querySelector('[data-dc-colors]');
      if (src) {
        try { this.colors = JSON.parse(src.getAttribute('data-dc-colors') || '[]'); } catch (e) {}
        if (!this.imgs.length) this.imgs = this.colors.map((c) => c.image).filter(Boolean);
      }
      this.img = this.querySelector('[data-star-img]');
      this.i = 0;
      if (!this.img || this.imgs.length < 2) return;

      const show = (n) => {
        this.i = (n + this.imgs.length) % this.imgs.length;
        this.img.style.opacity = '0';
        setTimeout(() => { this.img.src = this.imgs[this.i]; this.img.style.opacity = '1'; }, 250);
        this.querySelectorAll('[data-star-index]').forEach((s) => s.classList.toggle('is-active', parseInt(s.dataset.starIndex, 10) === this.i));
        this.sync();
      };

      this.addEventListener('click', (e) => {
        const sw = e.target.closest('[data-star-index]');
        if (sw) { this.stop(); show(parseInt(sw.dataset.starIndex, 10)); }
      });

      // El auto-ciclado es decorativo: no se ejecuta si el usuario pidió menos movimiento.
      // Los swatches siguen funcionando en ese caso.
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) {
        const every = parseInt(this.dataset.interval || '4200', 10);
        this.timer = setInterval(() => show(this.i + 1), every);
      }
      this.sync();
    }

    // Refleja el color activo en el resto de la tarjeta (nombre, precio, variante del carrito).
    // Se limita a este elemento: nunca toca otras tarjetas ni la landing.
    sync() {
      const c = this.colors[this.i];
      if (!c) return;
      // name vacío = el producto no tiene opción de color y se está ciclando su galería.
      if (c.name) {
        this.querySelectorAll('[data-color-name]').forEach((el) => { el.textContent = c.name; });
        this.querySelectorAll('[data-color-row]').forEach((el) => { el.hidden = false; });
      }
      if (c.price) this.querySelectorAll('[data-price]').forEach((el) => { el.textContent = c.price; });
      this.querySelectorAll('[data-compare]').forEach((el) => {
        el.textContent = c.compareAt || '';
        el.hidden = !c.compareAt;
      });
      // El badge de descuento viene calculado desde Liquid, igual que el tachado:
      // los dos salen de los mismos precios, así que no pueden discrepar.
      this.querySelectorAll('[data-disc]').forEach((el) => {
        el.textContent = c.discount || '';
        el.hidden = !c.discount;
      });
      if (c.id) this.querySelectorAll('[data-variant-id]').forEach((el) => { el.value = c.id; });
    }

    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    disconnectedCallback() { this.stop(); }
  }

  if (!customElements.get('dc-filters')) customElements.define('dc-filters', DCFilters);
  if (!customElements.get('dc-star')) customElements.define('dc-star', DCStar);
})();
